require('../../modules/es.map');
require('../../modules/es.object.to-string');
require('../../modules/es.string.iterator');
require('../../modules/web.dom-collections.iterator');
var path = require('../../internals/path');

module.exports = path.Map;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/es/map/index.js
// module id = 1036
// module chunks = 1